import {translation} from "@2d-front-monorepo/core";
import {PermitResult, Permits} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import {Link} from "react-router";
import {formatRoute, PrivateRoutes} from "../../../routes";
import {RenewComponent} from "./RenewComponent";

/** The group counterpart of {@link RenewComponent}: renews every sibling that can go into one
 *  multi-permit as a single operation - one charge, one approval. Siblings the backend would
 *  refuse to bundle (different dates, tariff, location, residency or payment method) are left out
 *  and can still be renewed one by one from the group page. */
export function RenewGroupComponent({permits, skipSingle}: { permits: PermitResult[], skipSingle?: boolean }): JSX.Element | undefined {
	const renewable = Permits.getRenewableGroup(permits);
	if (renewable.length === 0) {
		return undefined;
	}

	// A lone candidate is a plain renewal: the backend rejects a single vehicle group sent with
	// multi billing data (permits_invalid_billing_data_type). Callers that already list the permits
	// one by one - each with its own RenewComponent - pass `skipSingle` so the banner isn't shown twice.
	if (renewable.length === 1) {
		return skipSingle ? undefined : <RenewComponent permit={renewable[0]}/>;
	}

	const args = {renewable: renewable.length, total: permits.length};

	return (
		<div className={"padded inline"}>
			<p className={"layout horizontal aligned middle form-message form-message--warning"}>
				<span className={"flex"}>{translation(PermitTranslations.permit_page__renew_group__title, args)}</span>
				<Link className="form__button form__button--primary form__button--small"
				      to={formatRoute(PrivateRoutes.permitsRenew, renewable[0].id) + "?group=1"}>
					{translation(PermitTranslations.permit_page__renew_group__button, args)}
				</Link>
			</p>
		</div>
	);
}
